/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../extendIcon';

const FileAlt = props => (
  <svg viewBox="0 0 20 20" width="1em" height="1em" {...props}>
    <path d="M15.6 5.1L13 2.5c-.3-.3-.7-.5-1.1-.5H5.5C4.7 2 4 2.7 4 3.5v13c0 .8.7 1.5 1.5 1.5h9c.8 0 1.5-.7 1.5-1.5V6.1c0-.4-.2-.8-.4-1zm-.7.7s.1.1.1.2h-3V3c.1 0 .2.1.2.1l2.7 2.7zM14.5 17h-9c-.3 0-.5-.2-.5-.5v-13c0-.3.2-.5.5-.5H11v3.2c0 .5.3.8.7.8H15v9.5c0 .3-.2.5-.5.5zM13 9.4v.2c0 .2-.2.4-.4.4H7.4c-.2 0-.4-.2-.4-.4v-.2c0-.2.2-.4.4-.4h5.2c.2 0 .4.2.4.4zm0 2v.2c0 .2-.2.4-.4.4H7.4c-.2 0-.4-.2-.4-.4v-.2c0-.2.2-.4.4-.4h5.2c.2 0 .4.2.4.4zm0 2v.2c0 .2-.2.4-.4.4H7.4c-.2 0-.4-.2-.4-.4v-.2c0-.2.2-.4.4-.4h5.2c.2 0 .4.2.4.4z" />
  </svg>
);

export default extendIcon(FileAlt);
